import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Dispatch, RootState } from '../../store/store';
import SpinnerLoader from '../SpinnerLoader/SpinnerLoader';
import { CycleSettingAction } from '../../enums/action';
import { actions } from './constants';
import { IOnUpdateSettingField } from '../PostWeldSettings/PostWeldSettings';
import { useFormik } from 'formik';
import InputControl from '../InputControl/InputControl';
import InteractiveButton from '../InteractiveButton/InteractiveButton';

type ComponentProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch> & { cycleId: string };

const PercentageTimerSettings: React.FC<ComponentProps> = ({
  cycleId,
  clearSettings,
  updateSettings,
  cycleDbSettings,
  updateDbSettings,
}) => {
  const onUpdateSettingsHandler = async (action: CycleSettingAction, value: string) => {
    await updateSettings({
      id: cycleId,
      payload: { action, value },
    });
  };

  const onUpdateSettingField = async ({action, key, value}: IOnUpdateSettingField) => {
    const data = {}
    if(key === 'percentage_timer') {
      data['percentageTimer'] = value;
    }else {
      data[key] = value;
    }   
    await updateDbSettings({
      id: cycleId,
      payload: {
        cycleDbSettings: data,
      },
    });
    
    await onUpdateSettingsHandler(action, value);
  };

  useEffect(() => {
    return () => {
      clearSettings();
    };
  }, []);

  return (
    <div className="c-percentage-timer h-full w-full">
      {!cycleDbSettings && (
        <div className=" flex h-full w-full items-center justify-center">
          <SpinnerLoader />
        </div>
      )}
      {cycleDbSettings && (
        <>
          {actions.map((item) => {
            const formik = useFormik({
              initialValues: {
                [item.actionField]: cycleDbSettings[item.actionField]?.value || cycleDbSettings['percentageTimer'],
              },
              validationSchema: item?.validationSchema,
              onSubmit: async (val) => {
                await onUpdateSettingField({ action: item.actionName, key: item.editableKey, value: String(val[item.actionField]) })
              },
            });
            return (
              <form key={item.actionName} className="p-7" onSubmit={formik.handleSubmit}>
                <div className='flex w-full flex-col max-md:gap-y-4 md:flex-row justify-between'>
                  <div className='flex w-full'>
                    <div className="w-full">
                      <InputControl
                        label={item.labelText}
                        type={item.inputType}
                        name={item.actionField}
                        value={formik.values[item.actionField]}
                        customOnChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        showError={formik.touched[item.actionField] && formik.errors[item.actionField]}
                        errorText={formik.errors[item.actionField]}
                      />
                      <InteractiveButton
                        text={'Update'}
                        submit
                        isLoading={formik.isSubmitting}
                      />
                    </div>
                    
                  </div>
                </div>
              </form>
              // <SingleValueForm
              //   key={item.actionName}
              //   type={item.inputType}
              //   values={{
              //     [item.actionField]: cycleDbSettings[item.actionField]?.value,
              //   }}
              //   label={item.labelText}
              //   currentValues={cycleDbSettings[item.actionField]}
              //   onSubmit={(val) => onUpdateSettingField({ action: item.actionName, key: item.editableKey, value: String(val[item.actionField]) })}
              //   validationSchema={item?.validationSchema}
              // />
            );
          })}
        </>
      )}
    </div>
  );
};

const mapState = (state: RootState) => ({
  cycleDbSettings: state.cycles.cycleDbSettings,
});

const mapDispatch = (dispatch: Dispatch) => ({
  clearSettings: dispatch.cycles.clearSettings,
  updateSettings: dispatch.cycles.updateSettings,
  updateDbSettings: dispatch.cycles.updateDbSettings,
});

export default connect(mapState, mapDispatch)(PercentageTimerSettings);
